import { render, staticRenderFns } from "./shopSignedRemark.vue?vue&type=template&id=56c49f9c&scoped=true"
import script from "./shopSignedRemark.vue?vue&type=script&lang=js"
export * from "./shopSignedRemark.vue?vue&type=script&lang=js"
import style0 from "./shopSignedRemark.vue?vue&type=style&index=0&id=56c49f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c49f9c",
  null
  
)

export default component.exports